// extracted by mini-css-extract-plugin
export default {"activeTab":"MapView_activeTab__NgL-c","activeSvg":"MapView_activeSvg__CDGQc"};